let React = require('react');
import TableRow from './TableRow.jsx';
import TableRowEdit from './TableRowEdit.jsx';
import TableRowItalic from './TableRowItalic.jsx';
import TableRowItalicEdit from './TableRowItalicEdit.jsx';

let TableBody = React.createClass({
    createRow(row, novedadEmpresa, novedadEmpresaEditado, admId, selId, editId, editadoId, listNovedadEditado, editNotifyFn) {
        let novedad = novedadEmpresa.find(x => x.EmpresaId === row.Id);
        let flag = null;
        let flagEditado = null;

        if (row.AdministradoraId === admId || row.esNueva) {
            if (row.Id === selId) {
                if (row.Id === editId) {
                    flag = true
                }
                else {
                    flag = false
                }

                if (row.Id === editadoId) {
                    flagEditado = true
                }
                else {
                    flagEditado = false
                }

                if (novedad === undefined) {
                    return (
                        <TableRowEdit row={row} novedad={novedad} listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ENT_" + row.Id} editRow={flag} editNotifyFn={editNotifyFn}
                            comienzoDeEdicion={this.props.comienzoDeEdicion}
                            desaparicionLapizEdicion={this.props.desaparicionLapizEdicion}
                            cancelEdicionLimite={this.props.cancelEdicionLimite}
                            aceptarEdicion={this.props.aceptarEdicion}
                            modificacionLimite={this.props.modificacionLimite} />
                    );
                } else {
                    return (
                        <TableRowItalicEdit row={row} novedad={novedad} listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ENT_" + row.Id} editRow={flag} editadoRow={flagEditado} editNotifyFn={editNotifyFn}
                            comienzoDeEdicion={this.props.comienzoDeEdicion}
                            desaparicionLapizEdicion={this.props.desaparicionLapizEdicion}
                            cancelEdicionNovedad={this.props.cancelEdicionNovedad}
                            aceptarEdicion={this.props.aceptarEdicion}
                            modificacionNovedad={this.props.modificacionNovedad} />
                    );
                }
            }
            else {

                if (row.Id === editadoId) {
                    flagEditado = true
                }
                else {
                    flagEditado = false
                }

                if (novedad === undefined) {
                    return (
                        <TableRow row={row} novedad={novedad} listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ENT_" + row.Id} aparicionLapizEdicion={this.props.aparicionLapizEdicion} />
                    );
                } else {
                    return (
                        <TableRowItalic row={row} novedad={novedad} listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ENT_" + row.Id} editRow={flag} editadoRow={flagEditado}
                            aparicionLapizEdicion={this.props.aparicionLapizEdicion}
                            muestraEditadoNovedad={this.props.muestraEditadoNovedad}
                            ocultaEditadoNovedad={this.props.ocultaEditadoNovedad} />
                    );
                }
            }
        }
    
    },

    render: function () {
        let editNotifyFn = this.props.editNotifyFn;
        let novedadEmpresaEditado;
        let novedadEmpresa;
        let listNovedadEditado;

        if (this.props.data.novedadesEmpresas !== undefined) {
            novedadEmpresaEditado = listNovedadEditado = this.props.data.novedadesEmpresas;
            novedadEmpresa = this.props.data.novedadesEmpresas != undefined ? JSON.parse(JSON.stringify(this.props.data.novedadesEmpresas)) : this.props.data.novedadesEmpresas;
        } else {
            novedadEmpresa = listNovedadEditado = this.props.data.novedadesEmpresas != undefined ? JSON.parse(JSON.stringify(this.props.data.novedadesEmpresas)) : this.props.data.novedadesEmpresas;
            novedadEmpresaEditado = undefined;
        }

        let rows = null;
        let mapRow = [];
        let i = 0;
        let selId = this.props.data.selectedId;
        let editId = this.props.data.editId;
        let editadoId = this.props.data.editadoId;
        let admId = parseInt(this.props.data.administradoraSeleccionadaId);
        let functions = this.props.data.functions;

        if (this.props.data.empresas === undefined || this.props.data.empresas.length === 0) {
        }
        else {
            let me = this;
            if (this.props.data.empresas != undefined) {
                if (functions.Confidencial == true) {
                    rows = this.props.data.empresas.map(function (row) {
                        return me.createRow(row, novedadEmpresa, novedadEmpresaEditado, admId, selId, editId, editadoId, listNovedadEditado, editNotifyFn);
                    });
                }
                else {
                    rows = this.props.data.empresas.map(function (row) {
                        
                        if (row.EsConfidencial == false) {
                            return me.createRow(row, novedadEmpresa, novedadEmpresaEditado, admId, selId, editId, editadoId, listNovedadEditado, editNotifyFn);
                        }
                        else {
                            return null;
                        }
                    });
                }

                rows.map(function (row) {
                    if (rows[i] != undefined) {
                        mapRow.push(rows[i]);
                    }
                    i += 1;
                });

                if (mapRow[0] === undefined) {
                    rows =
                        <div className="row">
                            <div className="col-md-1">
                            </div>
                            <div className="col-md-11">
                                <label className="label-primary">Aun no existen empresas para ésta administadora</label>
                            </div>
                        </div>
                }
            }
        }
        
        return (
            <div>
                {rows}
            </div>
        );
    }
});

export default TableBody